import React from 'react';
import lang from '@practicegenius/register-account/src/lang';
import {UseMachineType} from '@practicegenius/register-account/src/machines/useAccountRegistrationMachineType';

type Props = {
  registrationMachine: UseMachineType;
};

export const WarnBeforeLeaving: React.FCC<Props> = props => {
  const [
    {
      context: {registrationCompleted},
    },
  ] = props.registrationMachine;

  React.useEffect(() => {
    const message = lang.general.lostProgressWarning;

    const prompt = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = message;
      return message;
    };

    if (!registrationCompleted) {
      window.addEventListener('beforeunload', prompt);
    } else {
      window.removeEventListener('beforeunload', prompt);
    }

    return () => window.removeEventListener('beforeunload', prompt);
  }, [registrationCompleted]);

  return <>{props.children}</>;
};
